import createReducer from "./createReducer";
import * as types from "../constants/ActionTypes";
import { RootState } from ".";
import { Reducer } from "redux";
import { ActionPayload, Choice, ID } from "../../types";
import {
  AddChoicePayload,
  RemoveChoicePayload,
  SetQuantityPayload,
} from "../actions/choiceActions";

export interface ChoiceState {
  byId: {
    [key: ID]: Choice;
  };
  allIds: ID[];
}
type ChoiceReducer<T> = Reducer<ChoiceState, ActionPayload<T>>;

export type GetTotalPriceFn = (
  state: RootState
) => (withDiscount: boolean) => number;

const choiceInitialState = { byId: {}, allIds: [] };
// Price Total Selector
export const getTotalPrice: GetTotalPriceFn = (state) => (withDiscount) => {
  return Object.values(state.choices.byId).reduce((acc, item) => {
    const fullprice =
      typeof item.price === "string" ? parseFloat(item.price) : item.price;
    const discount =
      typeof item.discount === "string"
        ? parseFloat(item.discount)
        : item.discount;
    let price = 0;
    price = !fullprice ? 0 : fullprice * item.quantity;
    if (withDiscount) {
      price =
        discount == null || isNaN(discount) ? price : discount * item.quantity;
    }
    if (state.packaged.allIds.includes(item.id)) return acc + 0;
    return acc + price;
  }, 0);
};

const setQuantity: ChoiceReducer<SetQuantityPayload> = (state, action) => {
  if (!state) return choiceInitialState;
  const { payload } = action;
  const { id, amount } = payload;

  const part = state.byId[id];
  if (!part) return state;

  return {
    byId: { ...state.byId, [id]: { ...part, quantity: amount } },
    allIds: [...state.allIds],
  };
};

const addChoice: ChoiceReducer<AddChoicePayload> = (state, action) => {
  if (!state) return choiceInitialState;
  const { payload } = action;
  const { part } = payload;

  const all = state.allIds.includes(part.id)
    ? [...state.allIds]
    : [...state.allIds, part.id];
  return {
    byId: { ...state.byId, [part.id]: { ...part, quantity: 1 } },
    allIds: all,
  };
};

const removeChoice: ChoiceReducer<RemoveChoicePayload> = (state, action) => {
  if (!state) return choiceInitialState;
  const { payload } = action;
  const { id } = payload;

  const { [id]: value, ...theRest } = state.byId;
  const filtered = state.allIds.filter((el) => el !== id);
  return {
    byId: { ...theRest },
    allIds: [...filtered],
  };
};

const choiceReducer = createReducer<ChoiceState>(choiceInitialState, {
  [types.ADD_CHOICE]: addChoice,
  [types.REMOVE_CHOICE]: removeChoice,
  [types.SET_CHOICE_QUANTITY]: setQuantity,
});
export default choiceReducer;
